
import Component from 'vue-class-component';
import Vue from 'vue';
import { Prop } from 'vue-property-decorator';
import { LoanStatus } from '@/loan/enums/loan-status';

@Component
export default class LoanNavOverview extends Vue {
	@Prop({ required: true })
	public status!: LoanStatus;

	@Prop({ required: true })
	public loanId!: string;

	get isActive(): boolean {
		return this.status === LoanStatus.ACTIVE || this.status === LoanStatus.HOLD;
	}
}

